import { type ReactNode } from 'react';

import { Divider, useMediaQuery, useTheme } from '@mui/material';

export type ResponsiveActionsLayoutProps = {
  children?: ReactNode;
};

const ResponsiveActionsLayout = ({
  children,
}: ResponsiveActionsLayoutProps) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  if (!isTablet) {
    return (
      <>
        <Divider />
        {children}
      </>
    );
  }

  return null;
};

export default ResponsiveActionsLayout;
